export const typingTimeoutValue = 200;

export const ASC = "asc";
export const DESC = "desc";
export const FOOT = "foot";
export const FEET = "feet";
export const KNEE = "knee";
export const KNEES = "knees"
